import React from 'react';

const Tour = () => {
  return (
    <div className="container mt-5">
      <div className="row">
        {/* Video Section */}
        <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
          <div className="card shadow-lg p-3 mt-5 mb-5 video" style={{ border: 'none' }}>
           
            {/* <video
  className="w-100 rounded"
controls
  controlsList="nodownload"
  onContextMenu={(e) => e.preventDefault()} // disables right-click
  style={{ maxHeight: "400px", objectFit: "cover" }}
>
<source src="https://youtu.be/em6F8PmrRoY?si=c3dJpMsFWLFF09vv" type="video/mp4" />
Your browser does not support the video tag.
</video> */}
<iframe width="100%" height="320"
 src="https://www.youtube.com/embed/VrmkPfr-zMM?si=U6y4tQkYfXQ8uU0R"
  title="YouTube video player" frameborder="0"
    referrerpolicy="strict-origin-when-cross-origin"
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
  allowfullscreen
  ></iframe>
          </div>
        </div>

        {/* Content Section */}
        <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
          <h3 className="mb-3 mt-5">Take a Quick Product Tour</h3>
          <p>
            Discover how our AI-powered post automation platform can save you time, boost
            engagement, and streamline your social media workflow. Watch this short demo to
            see how easy it is to create, schedule, and publish content across multiple
            platforms — all in just a few clicks.
          </p>
          <p>
            Learn how our smart automation and intuitive dashboard make managing your content
            effortless — so you can focus on growing your brand, not juggling platforms.
          </p>
        </div>
      </div>
<div class="alert alert-primary mt-3" role="alert" style={{fontSize:'12px',fontWeight:'bold'}}>
            By posting or scheduling content through this platform, I confirm that I am the rightful owner or have the necessary rights to share the content, and I grant my full consent for this platform to use, store, and publish my posts on my behalf across connected networks.
</div>
    </div>
  );
};

export default Tour;
